export const TIERS = {
  free: {
    name: 'Abstracts',
    monthlyLimit: 5,
    batchLimit: 1,
    price: 0,
  },
  reading_list: {
    name: 'Reading List',
    monthlyLimit: 50,
    batchLimit: 5,
    price: 6,
  },
  dissertation: {
    name: 'Dissertation',
    monthlyLimit: 200,
    batchLimit: 20,
    price: 15,
  },
  lab: {
    name: 'Lab',
    monthlyLimit: Infinity,
    batchLimit: Infinity,
    price: 39,
  },
} as const;

export type TierKey = keyof typeof TIERS;

export const API_BASE = process.env.REACT_APP_API_URL 
  || 'https://desk-reject-production.up.railway.app';

export const MAX_FILE_SIZE_MB = 50;
export const EVALUATION_TIMEOUT_MS = 120000;